import { RoleName } from '@/common/const/Auth';

const CanonicalRoleNames = Object.values(RoleName);
const CanonicalRoleNameByLowerCase = new Map(
  CanonicalRoleNames.map((roleName) => [roleName.toLowerCase(), roleName]),
);

const hasPolicyNames = (policyNames?: string[] | null): boolean =>
  Array.isArray(policyNames) &&
  policyNames.some((policyName) => (policyName ?? '').trim() !== '');

export const normalizeLegacyRoleName = (
  roleName?: string | null,
  {
    techFamily,
    policyNames,
  }: {
    techFamily?: string | null;
    policyNames?: string[] | null;
  } = {},
): string => {
  const trimmedRoleName = roleName?.trim() ?? '';
  const canonicalRoleName = CanonicalRoleNameByLowerCase.get(
    trimmedRoleName.toLowerCase(),
  );

  if (canonicalRoleName) return canonicalRoleName;

  if (hasPolicyNames(policyNames)) return trimmedRoleName;

  const trimmedTechFamily = techFamily?.trim() ?? '';

  if (
    !trimmedTechFamily ||
    !trimmedRoleName.toLowerCase().startsWith(trimmedTechFamily.toLowerCase())
  ) {
    return trimmedRoleName;
  }

  const suffix = trimmedRoleName
    .slice(trimmedTechFamily.length)
    .replace(/^[\s:_-]+/, '')
    .trim();

  return (
    CanonicalRoleNameByLowerCase.get(suffix.toLowerCase()) ?? trimmedRoleName
  );
};
